/** In-app notifications (docs/specs/notifications.md): `type` + `data` from the API, the words from here. */
export const notifications = {
    title: "Notifications",
    open: "Notifications",
    unread: "{{count}} unread",
    empty: "You're all caught up.",
    markAllRead: "Mark all read",
    types: {
        role_assigned: "You were given the {{roleName}} role.",
        stock_negative: "{{productName}} ({{sku}}) went below zero: {{onHand}} on hand.",
        pos_sync_stalled: "{{deviceName}} has {{pendingCount}} bills waiting to sync.",
        report_ready: "Your {{report}} export is ready to download.",
        report_failed: "Your {{report}} export could not be made. Try again.",
        billing_payment_approved: "Your payment of {{amount}} is approved. {{detail}} is active.",
        billing_dunning: "Your subscription needs a payment ({{date}}). Open Plan & billing.",
        billing_payment_rejected: "Your payment of {{amount}} was not approved: {{detail}}",
        plan_limit_warning: "You've used {{usage}} of the {{limit}} your plan allows ({{level}}%). Upgrade to add more.",
    },
};
//# sourceMappingURL=notifications.js.map